<template>
  <div class="p-fluid">
    <div class="card">
      <h5 class="p-text-center">Edición de configuracion de email</h5>
      <form @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="p-field">
          <label
            for="name"
            :class="{ 'p-error': v$.name.$invalid && submitted }"
            >Name*</label
          >
          <InputText
            id="name"
            v-model="v$.name.$model"
            :class="{ 'p-invalid': v$.name.$invalid && submitted }"
          />
          <small
            v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response"
            class="p-error"
            >{{ v$.name.required.$message.replace('Value', 'Name') }}</small
          >
        </div>

        <div class="p-field">
          <label for="plantilla">Plantilla</label>
          <Dropdown
            id="plantilla"
            v-model="v$.plantilla.$model"
            :options="plantillas"
            optionLabel="name"
            placeholder="Select Plantilla"
          ></Dropdown>
        </div>

        <div class="p-field">
          <label
            for="subjectText"
            :class="{ 'p-error': v$.subjectText.$invalid && submitted }"
            >Email*</label
          >
          <InputText
            id="subjectText"
            v-model="v$.subjectText.$model"
            :class="{ 'p-invalid': v$.subjectText.$invalid && submitted }"
          />
          <small
            v-if="
              (v$.subjectText.$invalid && submitted) ||
                v$.subjectText.$pending.$response
            "
            class="p-error"
            >{{
              v$.subjectText.required.$message.replace('Value', 'Subject')
            }}</small
          >
        </div>

        <div class="p-field-checkbox">
          <InputSwitch id="active" v-model="v$.active.$model" />
          <label class="p-label" for="active">Activo</label>
        </div>

        <div class="p-d-flex p-jc-center">
          <div class="p-mr-2"><Button type="submit" label="Guardar" /></div>
          <router-link to="/emailconfig">
            <div class="p-mr-2"><Button type="button" label="Cancel" /></div>
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPut } from '../../helpers/rest-api';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      id: '',
      plantillas: [],
      plantilla: { id: 88, name: 'Email' },
      name: '',
      subjectText: '',
      active: false,
      submitted: false,
    };
  },
  validations() {
    return {
      name: {
        required,
      },
      plantilla: {
        required,
      },
      subjectText: {
        required,
      },
      selectedRoles: {
        required,
      },
      active: {
        required: false,
      },
    };
  },
  mounted() {
    this.getPlantillas();

    this.getId(this.$router.currentRoute.value.params.id);
  },

  methods: {
    getPlantillas() {
      apiGet('plantilla').then((response) => (this.plantillas = response.data));
    },

    getId(id) {
      apiGet(`emailconfig/${id}`).then(
        (response) => (
          (this.name = response.data.name),
          (this.id = response.data.id),
          (this.plantilla = response.data.plantilla),
          (this.subjectText = response.data.subjectText),
          (this.active = response.data.active)
        )
      );
    },

    handleSubmit() {
      this.submitted = true;
      const { name, plantilla, subjectText, id, active } = this;

      apiPut(
        `emailconfig/${id}`,
        JSON.stringify({ name, plantilla, subjectText, active })
      ).then(() => this.$router.push('/emailconfig'));
    },
  },
};
</script>
